<template>
  <div class="card">
    <div style="margin-bottom:10px;">Product No.: {{ $route.params.id }}</div>
    <el-row style="margin-top:5px;">
      <el-col :span="24">
        <table class="fixed-table">
          <tr>
            <th style="width:76px;">Issue Date</th>
            <th style="width:94px;">Delivery Date</th>
            <th style="width:84px;">PO No.</th>
            <th>Company</th>
            <th style="width:52px;">HK Stk</th>
            <th style="width:52px;">SZ Stk</th>
            <th style="width:46px;">BB</th>
            <th style="width:62px;">Cost</th>
            <th style="width:70px;background:#800080;color:#fff;">Type</th>
            <th style="width:50px;background:#800080;color:#fff;">Qty</th>
            <th style="width:62px;background:#800080;color:#fff;">Price</th>
            <th style="width:140px;background:#800080;color:#fff;">Buyer</th>
            <th style="width:78px;">Sales</th>
          </tr>
          <template v-for="(item, index) in list">
            <tr :key="index">
              <td>{{item.doc_date}}</td>
              <td>{{item.delivery_date}}</td>
              <td v-if="(user.role_id < 3 || item.create_oper_id == user.id)"><a @click="$open(`/po-order-view/${item.doc_id}`, 840)">{{item.doc_id_display}}</a></td>
              <td v-else>{{item.doc_id_display}}</td>
              <td v-if="(user.role_id < 3 || item.create_oper_id == user.id)" :title="item.company_fullname">{{item.company_fullname}}</td>
              <td v-else></td>
              <td style="text-align:right;">{{item.qty_hk|1000}}</td>
              <td style="text-align:right;">{{item.qty_sz|1000}}</td>
              <td style="text-align:right;">{{item.qty_bb|1000}}</td>
              <td><span style="color:#6f76b1">{{item.currency}}</span>{{item.price|1000}}</td>
              <td colspan="4">
                <table class="fixed-table inner-table">
                  <tr v-for="s in item.solds">
                    <td style="width:70px;">INV-{{ s.type }}</td>
                    <td style="width:50px;">{{s.qty|1000}}</td>
                    <td style="width:62px;"><span style="color:#6f76b1">USD</span>{{s.price}}</td>
                    <td :title="s.company" v-if="(user.role_id < 3 || item.create_oper_id == user.id)">{{s.company}}</td>
                  </tr>
                </table>
              </td>
              <td>{{item.sales_fullname}}</td>
            </tr>
          </template>
        </table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      list: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.$http('/dbapi/po_list?product_id=' + this.$route.params.id).then(data => {
        this.list = data.list
        return this.$http.get('/dbapi/po_sold_list', {
          params: {
            ids: this.list.map(r => r.id)
          },
          paramsSerializer: function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        })
      }).then(data => {
        if (data.list.length > 0) {
          let list = this.list.slice()
          let solds = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].solds = []
            for (let k = 0; k < solds.length; k++) {
              if (solds[k].po_id === list[i].id) {
                list[i].solds.push(solds[k])
              }
            }
          }
          this.list = list
        }
      })
    }
  }
}
</script>
